import React from 'react';

import { IIconProps, TIconType } from '../interface';

const LogOutIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='logout'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M16 8L20 12L16 16'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10 12H20'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10 20H4.75C4.55109 20 4.36032 19.9234 4.21967 19.787C4.07902 19.6506 4 19.4656 4 19.2727V4.72727C4 4.53439 4.07902 4.3494 4.21967 4.21301C4.36032 4.07662 4.55109 4 4.75 4H10'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default LogOutIcon;
